import React from "react";
import ReactDOM from "react-dom/client";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import { Provider } from "react-redux";
import "./index.less";
import App from "./App";
import moment from "moment";
import "moment/locale/zh-tw";
import { secureStroge, storgeKeys } from "@utils";
moment.locale("zh-tw");

// 使用 reducer 函數，建立 Store 實例，Store 會將改變狀態邏輯委託給 reducer 實作
const preloadedState = secureStroge.get(storgeKeys.userCredential) || {};
const preStore = {
  auth: { userInfo: preloadedState }
};
const store = createStore(
  rootReducer,
  preStore,
  // Debug 工具，方便除錯與掌握 store 資料狀況
  composeWithDevTools(
    // 將 middleware 依序傳遞進 applyMiddleware, ex: applyMiddleware(middleware1, middleware2, ...)
    // 將回傳的 enhancer 函數傳遞給 createStore
    applyMiddleware(thunk)
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
